import { AlertTriangle } from 'lucide-solid';
import { type Component, type JSX, Match, Show, Switch } from 'solid-js';
import { errorViewOf, loadErrorHint, type QueryStateSignals } from '@sportpark/shared/query-view';
import { Button } from '~/shared/ui/Button';
import { EmptyState } from '~/shared/ui/EmptyState';
import { Skeleton } from '~/shared/ui/Skeleton';

export const LoadError: Component<{
  title: string;
  error: unknown;
  onRetry: () => void;
  retrying?: boolean;
}> = (props) => (
  <EmptyState
    illustration={<AlertTriangle class="h-12 w-12" />}
    title={props.title}
    hint={loadErrorHint(props.error)}
    action={
      <Button variant="secondary" size="sm" loading={props.retrying} onClick={() => props.onRetry()}>
        Повторить
      </Button>
    }
  />
);

export const StaleNotice: Component<{ onRetry: () => void; retrying?: boolean; message?: string }> = (props) => (
  <div
    role="alert"
    class="mb-3 flex items-center gap-3 rounded-md border border-hairline px-3 py-2 text-[13px] text-secondary"
  >
    <span class="flex-1">{props.message ?? 'Не удалось обновить — показаны прежние данные'}</span>
    <Button variant="ghost" size="sm" loading={props.retrying} onClick={() => props.onRetry()}>
      Повторить
    </Button>
  </div>
);

const DefaultSkeleton = () => (
  <div class="flex flex-col gap-3 py-6" aria-busy="true">
    <Skeleton height="56px" />
    <Skeleton height="56px" />
    <Skeleton height="56px" />
  </div>
);

export const QueryState: Component<{
  view: QueryStateSignals;
  errorTitle: string;
  skeleton?: JSX.Element;
  isEmpty?: boolean;
  empty?: JSX.Element;
  children: JSX.Element;
}> = (props) => {
  const errorView = () => errorViewOf(props.view.isError, props.view.hasData);
  return (
    <Switch>
      <Match when={props.view.isLoading && !props.view.hasData}>{props.skeleton ?? <DefaultSkeleton />}</Match>
      <Match when={errorView() === 'card'}>
        <LoadError
          title={props.errorTitle}
          error={props.view.error}
          onRetry={props.view.onRetry}
          retrying={props.view.isRetrying}
        />
      </Match>
      <Match when={true}>
        <Show when={errorView() === 'stale'}>
          <StaleNotice onRetry={props.view.onRetry} retrying={props.view.isRetrying} />
        </Show>
        <Show when={props.isEmpty} fallback={props.children}>
          {props.empty}
        </Show>
      </Match>
    </Switch>
  );
};
